"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_components_1 = __importStar(require("styled-components"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const ActionButtons_1 = __importDefault(require("../common/ActionButtons"));
const CloseIconButton_1 = __importDefault(require("../common/CloseIconButton"));
const styles_1 = require("../common/styles");
const StyledDialog = (0, styled_components_1.default)(Dialog_1.default) `
  .MuiPaper-rounded {
    border-radius: 8px;
    max-width: ${(props) => `${props.$maxWidth}px`};
  }
`;
const StyledTitle = (0, styled_components_1.default)(styles_1.Title) `
  padding: ${(props) => props.customPadding || "27px 0 19px 24px"};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: ${(props) => props.customPadding || "1px 0 21px 21px"};
  }
`;
const StyledSubTitle = (0, styled_components_1.default)(styles_1.SubTitle) `
  margin-top: 0;
  padding: 0px 24px 19px 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0px 21px 21px 21px;
  }
`;
const ModalHeader = styled_components_1.default.div `
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.customPadding || "5px"};
`;
const ModalTitle = styled_components_1.default.div `
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const ModalContent = (0, styled_components_1.default)(DialogContent_1.default) `
  &.MuiDialogContent-root {
    padding: ${(props) => (props.$topDivider ? "32px" : "0 32px 32px")};

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
      padding: ${(props) => (props.$topDivider ? "24px" : "0 24px 24px")};
    }
    ${(props) => props.customPadding &&
    (0, styled_components_1.css) `
        padding: ${props.customPadding} !important;
      `}
  }
`;
const ModalFooter = (0, styled_components_1.default)(DialogActions_1.default) `
  &.MuiDialogActions-root {
    padding: 24px 32px;
    flex-direction: ${(props) => (props.$actionsAsColumn ? "column" : "row")};
    @media (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
      padding: 24px 16px;
    }
  }
  &.MuiDialogActions-root .MuiButtonBase-root:first-child {
    margin-bottom: ${(props) => (props.$actionsAsColumn ? "16px" : "0px")};
  }
`;
/**
 * Generic modal component.
 *
 * Extends Material's Dialog component.
 * See https://material-ui.com/api/dialog/ for full list of available props.
 */
const Modal = ({ title, subTitle, onClose, children, actions, hideCloseIcon, maxWidth, open = true, modalContentPadding, modalTitlePadding, topDivider = true, drawerHeight, renderLargeSubTitle, actionsAsColumn, ...rest }) => ((0, jsx_runtime_1.jsxs)(StyledDialog, { "$maxWidth": maxWidth, "aria-labelledby": "form-dialog-title", "data-testid": "buoy-modal", onClose: onClose, open: open, ...rest, children: [(!hideCloseIcon || title || subTitle) && ((0, jsx_runtime_1.jsxs)(ModalHeader, { "data-testid": "modal-header", customPadding: modalContentPadding, children: [(0, jsx_runtime_1.jsxs)(ModalTitle, { children: [title && ((0, jsx_runtime_1.jsx)(StyledTitle, { id: "form-dialog-title", customPadding: modalTitlePadding, children: title })), !hideCloseIcon && (0, jsx_runtime_1.jsx)(CloseIconButton_1.default, { onClose: onClose })] }), subTitle &&
                    (renderLargeSubTitle ? ((0, jsx_runtime_1.jsx)(StyledTitle, { children: subTitle })) : ((0, jsx_runtime_1.jsx)(StyledSubTitle, { children: subTitle })))] })), children && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [topDivider && (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(ModalContent, { "$topDivider": topDivider, customPadding: modalContentPadding, children: children })] })), actions && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(ModalFooter, { "$actionsAsColumn": actionsAsColumn, children: (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { actions: actions }) })] }))] }));
exports.default = Modal;
//# sourceMappingURL=index.js.map